import { render, staticRenderFns } from "./CriticalThinking.vue?vue&type=template&id=58f8a8cc&"
import script from "./CriticalThinking.vue?vue&type=script&lang=js&"
export * from "./CriticalThinking.vue?vue&type=script&lang=js&"
import style0 from "./CriticalThinking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports